import { DataContext } from 'entries/common/widgets/context';
import { Counter, Price, Typography } from 'fronton-react';
import { SMALL_FALLBACK_PRODUCT_IMAGE_URL } from 'pages/common/components/Product/fallback-product-images.const';
import React, { ChangeEvent, useContext, useEffect, useRef } from 'react';
import { useCalculationState } from 'pages/calculation/store/calculation';
import { gaImpressionsProduct } from 'ga-events/ga-impressions-product';
import {
  CounterAndPriceContainer,
  MainProductBlock,
  MainProductContainer,
  MainProductImageAndName,
  PriceColumnContainer,
} from './styles';

export const MainProductComponent = () => {
  const productRef = useRef<HTMLDivElement>(null);
  const data = useContext(DataContext);
  const { calculationFormState, setCalculationState, calculatedPrice } = useCalculationState();

  const handleChangeCounter = (_event: ChangeEvent<HTMLInputElement>, value: string): void => {
    setCalculationState(prevState => ({
      ...prevState,
      count: value,
    }));
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting) {
          gaImpressionsProduct({
            name: data?.displayedName ?? '',
            id: data?.productId ?? '',
            price: `${data?.mainPrice ?? 0}`,
            position: '1',
          });
        }
      },

      {
        threshold: 0.5,
      }
    );

    if (productRef.current) {
      observer.observe(productRef.current);
    }

    return () => {
      if (productRef.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        observer.unobserve(productRef.current);
      }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps -- Нужно послать только один раз
  }, []);

  return (
    <MainProductBlock ref={productRef}>
      <Typography color="text-minor" size="body_short" variant="s">
        Основной товар
      </Typography>
      <MainProductContainer>
        <MainProductImageAndName>
          <img
            src={data?.photo || SMALL_FALLBACK_PRODUCT_IMAGE_URL}
            alt={data?.displayedName}
            loading="lazy"
            width={32}
            height={32}
          />

          <Typography variant="m" size="body_short" color="text-primary">
            {data?.displayedName}
          </Typography>
        </MainProductImageAndName>
        <CounterAndPriceContainer>
          <div>
            <Counter size="s" min={1} value={calculationFormState.count} onChange={handleChangeCounter} />
          </div>
          <PriceColumnContainer>
            <Price value={calculatedPrice} variant="medium" align="center" size="m" units="₽" />
          </PriceColumnContainer>
        </CounterAndPriceContainer>
      </MainProductContainer>
    </MainProductBlock>
  );
};
